import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=18259cae&scoped=true&v-if=loaded&"
import script from "./Issues.vue?vue&type=script&lang=ts&"
export * from "./Issues.vue?vue&type=script&lang=ts&"
import style0 from "./Issues.vue?vue&type=style&index=0&id=18259cae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18259cae",
  null
  
)

export default component.exports